import { render, staticRenderFns } from "./ChildProductsSection.vue?vue&type=template&id=46e0956e&scoped=true&lang=pug&"
import script from "./ChildProductsSection.vue?vue&type=script&lang=js&"
export * from "./ChildProductsSection.vue?vue&type=script&lang=js&"
import style0 from "./ChildProductsSection.vue?vue&type=style&index=0&id=46e0956e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e0956e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46e0956e')) {
      api.createRecord('46e0956e', component.options)
    } else {
      api.reload('46e0956e', component.options)
    }
    module.hot.accept("./ChildProductsSection.vue?vue&type=template&id=46e0956e&scoped=true&lang=pug&", function () {
      api.rerender('46e0956e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ChildProductsSection.vue"
export default component.exports